import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import whatsappIcon from '../../assets/chat_bubble_24dp_1F1F1F_FILL0_wght400_GRAD0_opsz24.svg';
import communityIcon from '../../assets/diversity_3_24dp_1F1F1F.svg';
import './Contact.css';

function Contact() {
  const { t } = useTranslation();

  return (
    <section className="contact-section" id="contact">
      <div className="contact-blur contact-blur-top"></div>
      <div className="contact-blur contact-blur-bottom"></div>
      
      <Container className="contact-container">
        <div className="contact-content">
          <h2 className="contact-title">{t('contact.readyToShine')}</h2>
          <p className="contact-description">
            {t('contact.limitedSlots')}
          </p>
          
          <div className="contact-buttons">
            <Button 
              href="#" 
              target="_blank"
              className="contact-button"
            >
              <img src={whatsappIcon} alt="WhatsApp" className="contact-icon" />
              {t('contact.whatsapp')}
            </Button>
            
            <Button 
              href="#" 
              target="_blank"
              className="contact-button"
            >
              <img src={communityIcon} alt="Community" className="contact-icon" />
              {t('contact.joinCommunity')}
            </Button>
          </div>
        </div>
      </Container>
    </section>
  );
}

export default Contact;
